module.exports = __webpack_public_path__ + "static/img/TA2000.cdf7932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA2000.png
// module id = zTjf
// module chunks = 0